import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import QCXFinalAlternativeCurrencyField from '../final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../final-select-moeda-field/QCXSelectMoedaAutocomplete';
import SelectTipoRateioDesconto from './QCXFinalSelectTipoRateioDesconto';

export default function QCXMoedaDescontoFormGroup({
  isConsult,
  handleValorNaMoedaOnBlur,
  valorValidators,
  submitSucceeded,
  intl,
  required = true,
}) {
  const { t } = useTranslation();

  const form = useForm();
  const { values } = useFormState();
  const tipo = values?.atributosAdicionais?.tipo;

  return (
    <>
      <Grid item xs={12} sm={12} md={2} lg={2}>
        <SelectTipoRateioDesconto
          id="select-tipo-rateio-desconto"
          key="select-tipo-rateio-desconto"
          name="desconto.tipoRateioDesconto"
          label="Tipo Rateio Desconto"
          disabled={isConsult}
          required={required}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2}>
        {tipo !== 'DUE' && (
          <QCXSelectMoedaAutocomplete
            id="select-field-moeda-desconto"
            key="select-field-moeda-desconto"
            name="desconto.moeda.id"
            label={t('com.muralis.qcx.moeda.moedaDesconto')}
            disabled={isConsult}
            initialValues={values}
            required={required}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-moeda-desconto-field"
          key="currency-valor-moeda-desconto-field"
          name="desconto.valorMoeda"
          label={t('com.muralis.qcx.moeda.valorDescontoMoeda')}
          validate={valorValidators}
          onBlur={handleValorNaMoedaOnBlur(form, values, 'desconto.moeda', 'desconto.valorMoeda', 'desconto.valorReal')}
          disabled={isConsult || !values?.desconto?.moeda?.id}
          submitSucceeded={submitSucceeded}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <QCXFinalAlternativeCurrencyField
          id="currency-valor-real-moeda-desconto-field"
          key="currency-valor-real-moeda-desconto-field"
          name="desconto.valorReal"
          label={t('com.muralis.qcx.moeda.valorDescontoReais')}
          intl={intl}
          adorned
          disabled
          submitSucceeded={submitSucceeded}
          helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
        />
      </Grid>
    </>
  );
}
